import { $body } from '../globals.js';

var $activity, $activities, $container,
    noOfQuestions, details, activityId, page, $interval;

var activityState = {
    rowAttempt: [],
    started: false,
    init: function (state) {
        this.started = !!state;
        for (var i = 0; i < noOfQuestions; i++) {
            this.rowAttempt.push(state && state.length > i ? parseInt(state[i], 10) : 1);
        }
    },
    toString: function () {
        return this.rowAttempt.join('');
    },
    save: function () {
        rebus.stateHelper.setElementState($activity, this.toString());
        rebus.stateHelper.save();
    }
};


var checkGroupCompletion = function ($activity) {


    var enable = $activities.filter(function( index ) {
        return $( this ).find('.checkbox-list .checked').length == 0;
    }).length? false : true;

    if(enable){
        clearInterval($interval);
        $interval = null;
    }
    $activity.find('.btn-submit-group').prop('disabled', !enable);

};


export default {
    dispose: function () {
        $('body').removeAttr('assess-attempt');
    },
    buildTemplates: function () {
        // The row templates must be added before panels.init() is called so that it can generate ids and lock panels
        $activity = $('[data-activity="multi-choice-grouped"]');
        page = rebus.navigation.getPage();
    },
    addQuestions: function () {
        // The questions must be added after panels.init(), so that we have access to the generated ids, and before the multiple choice
        // activity is initialized, so that the list items can be converted to options
        if ($activity.length) {
            $activity.data('storeid', page.storeId + 'multi-choice-grouped');
            var details = rebus.stateHelper.getElementDetails($activity);
            activityId = details.storeId;
            activityState.init(details.state);
        }
    },
    init: function (partial) {

        $container = $('[data-activity="multi-choice-grouped"]'),
        $activities = $container.find('[data-activity="multiple-choice-quiz"]');

        //hide all single activity submits
        $('.btn-check-multi-choice-answers', $container).hide();
        // now add a submit for entire group
        if( !$('.btn-submit-group', $container).length ){
            $('<button class="btn btn-primary btn-submit-group pink" disabled><span>Submit</span></button>').insertBefore( $('.grouped-activity-feedback', $container) );
        }

        setTimeout(function () {
            checkGroupCompletion($container);
        }, 500);

        $body.on('click', '.btn-submit-group', function () {
                
                $activities.each(function(idx, val){
                    var $type = $( this ).data('activity'),
                        $activityCorrect = false;
                        switch ( $type ){
                            case "multiple-choice-quiz":
                                if ( rebus.activities.multiChoiceQuiz.isCorrect( $activity ) ) {
                                    $activityCorrect = true;
                                }
                                break;
                            default:
                                break;
                        }
                        //
                        $( this ).find('.checkbox-list input').attr('disabled',true);
                        rebus.panels.setActivityAsComplete($( this ), true);
                        $( this ).find('.feedback')
                });

                rebus.panels.setActivityAsComplete($container, true);

                var fb = $('.grouped-activity-feedback', $container);
                    fb.show();
                    rebus.utils.scrollToAnchor(fb.find('.panel-anchor').attr('name'));
        });

        
        $container.off('click').on('click', '.checkbox-list input', function () {
            var $input = $(this);
            // set click on container items;
            if($interval == null){
                $interval = setInterval(function(){
                    checkGroupCompletion($container);
                }, 500);
            }
        });            
    }
};
